"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.shared.title': 'Conversaciones compartidas',
    'reports.shared.description': 'Ver conversaciones que han sido compartidas contigo por otros usuarios',
    'reports.shared.failedToLoad': 'Error al cargar conversaciones compartidas',
    'reports.shared.retryButton': 'Reintentar',
    'reports.shared.empty.title': 'Sin conversaciones compartidas',
    'reports.shared.empty.description': 'Aún no tienes conversaciones compartidas por otros usuarios.',
    'reports.shared.createdAt': 'Creado',
    'reports.shared.lastActivity': 'Última actividad',
    'reports.shared.model': 'Modelo de IA',
    'reports.shared.unknownModel': 'Modelo desconocido',
    'reports.shared.unknownUser': 'Usuario desconocido',
    'reports.shared.viewButton': 'Ver',
    'reports.shared.sharedWith': 'Compartido con',
    'reports.shared.noUsers': 'Sin usuarios',
};
